<template>
  <div class="ticket-details-display">
    <template v-if="!ticket.labels.includes('not-a-bug')">
      <div class="toolbar text-right">
        <p class="float-left">
          <span v-for="(label, index) in ticket.labels" class="badge" style="margin-right:2px" :key="index"
          v-if="label !== 'admin-issue' && label !== 'not-a-bug'"
          :class="{
            'badge-danger': label.includes('High Priority'),
            'badge-warning': label.includes('Priority'),
            'badge-info': !label.includes('Priority')
          }">{{ label }}</span>
        </p>
        <template v-if="isOpen">
          <button type="button" class="btn btn-primary" @click="executeAction('closeTicket')">
            <span class="fa fa-check-square"></span> Mark as Completed
          </button>
        </template>
        <template v-else>
          <button type="button" class="btn btn-primary" @click="executeAction('reopenTicket')">
            <span class="fa fa-ticket-alt"></span> Re-open Ticket
          </button>
        </template>
        <dropdown
            :dropUp="false"
            :title="'Priority Actions'"
            :icon="'fa fa-sort'"
            :actions="priorityActions"
            @action="executeAction($event)">
          </dropdown>
        <button type="button" class="btn btn-danger" @click="executeAction('deleteTicket')">
          <span class="fa fa-trash-alt"></span> Delete Ticket
        </button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="card card-primary mb-2">
            <div class="card-header">
              <span class="fa fa-ticket-alt fa-fw"></span>
              #{{ ticket.iid }} - {{ ticket.title }}
              <span class="badge badge-success float-right">
                {{ isOpen ? 'Open' : 'Completed' }}
              </span>
            </div>
            <div class="card-body">
              <p><strong>Submitted: </strong> {{ ticket.created_at | date_time_format }}</p>
              <div v-html="nl2br(ticket.description)"></div>
            </div>
          </div>
        </div>
      </div>
      <template v-for="(note, index) in notes">
        <div class="row" v-if="!note.system && !note.body.includes('I could not re-create this issue')" :key="index">
          <div class="col-11 offset-1">
            <div class="card border-dark mb-2" :class="{ 'bg-light': index % 2 == 0 }">
              <div class="card-header">
                <span class="fa fa-fw fa-reply"></span>
                Response from {{ note.author.id !== 10 ? note.author.name : 'Admin' }} - <i class="far fa-clock fa-fw" /> {{ note.created_at | date_time_format }}
              </div>
              <div class="card-body clearfix">
                <div v-html="nl2br(note.body)"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="card-footer text-right" v-if="isOpen">
        <button type="button" class="btn btn-primary" @click="reply()">
          <span class="fa fa-reply"></span> Reply
        </button>
      </div>
      <div v-else class="alert alert-danger">This issue has been marked as closed.</div>
    </template>
    <template v-else>
      <p class="callout callout-danger"><span class="fa fa-exclamation-triangle fa-fw"></span> Ticket has been deleted.</p>
    </template>
  </div>
</template>

<script>
import {
  LOAD_TICKET,
  CLOSE_TICKET,
  REOPEN_TICKET,
  DELETE_TICKET,
  ADD_TICKET_PRIORITY,
  REMOVE_TICKET_PRIORITY,
  OPEN_ERROR_MODAL,
  OPEN_MODAL
} from '@/vuex/types'
import { nl2br } from '@/util/filters'
import { mapGetters, mapActions } from 'vuex'
import Dropdown from '@/components/ui/Dropdown'

export default {
  name: 'TicketDetailsDisplay',
  components: { Dropdown },
  computed: {
    notes () {
      return this.ticket.notes
    },
    isOpen () {
      return this.ticket.state === 'opened'
    },
    ...mapGetters([
      'priorityActions',
      'ticket'
    ])
  },
  async mounted () { await this.displayTicket() },
  watch: {
    async $route () { await this.displayTicket() }
  },
  methods: {
    nl2br (text) {
      return nl2br(text).replace('<img', '<img style="max-width:100%;"')
    },
    async executeAction (action) {
      try {
        switch (action) {
          case 'addTicketPriorityHigh':
            await this[ADD_TICKET_PRIORITY]({ ticketId: this.$route.params.ticketId, ticketPriority: 'High Priority' })
            break
          case 'addTicketPriorityMedium':
            await this[ADD_TICKET_PRIORITY]({ ticketId: this.$route.params.ticketId, ticketPriority: 'Medium Priority' })
            break
          case 'addTicketPriorityLeast':
            await this[ADD_TICKET_PRIORITY]({ ticketId: this.$route.params.ticketId, ticketPriority: 'Low Priority' })
            break
          default:
            await this[action](this.$route.params.ticketId)
        }
        await this.displayTicket()
      } catch (err) {
        this.$store.dispatch(OPEN_ERROR_MODAL, err)
      }
    },
    async displayTicket () {
      try {
        await this.$store.dispatch(LOAD_TICKET, this.$route.params.ticketId)
      } catch (err) {
        this.$store.dispatch(OPEN_ERROR_MODAL, err)
      }
    },
    async reply () {
      await this.$store.dispatch(OPEN_MODAL, {
        permalink: 'replyTicket',
        params: this.$route.params,
        options: {
          title: 'Reply to Ticket',
          actionLabel: 'Reply'
        }
      })
    },
    ...mapActions([
      LOAD_TICKET,
      CLOSE_TICKET,
      REOPEN_TICKET,
      DELETE_TICKET,
      ADD_TICKET_PRIORITY,
      REMOVE_TICKET_PRIORITY
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/TicketDetailsDisplay.vue